<template>
  <UiSectionWrapper
    title="Kendala Pengiriman Bisa Terjadi, Tapi Kerugian Bisa Dicegah"
    sub-title="Sistem Undelivery"
    description="Aktifkan Undelivery KiriminAja sekarang dan jadilah yang pertama tahu saat paket gagal kirim."
    hero-image="/images/undelivery-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Gunakan Sekarang"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/undelivery'
      })
    "
  />
</template>
